import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { captureAttributionParams } from './utils/analytics';
import headLogo from './assets/head-logo.png';

// Set favicon (use head-logo.png from assets)
const favicon = document.querySelector("link[rel*='icon']") || document.createElement('link');
favicon.rel = 'icon';
favicon.href = headLogo;
if (!favicon.parentNode) {
  document.getElementsByTagName('head')[0].appendChild(favicon);
}

// Capture attribution parameters on page load
captureAttributionParams();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

